export default __webpack_public_path__ + "static/media/data-visualization-dashboard-essentials.8e245a62.png";